import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'

import { landAxios } from '@Root/utils/landAxios'
import OwnerArticleResponse from '@Types/entities/OwnerArticleResponse'
import ArticleDetail from '@Types/entities/ArticleDetail'
import ArticleFloor from '@Types/entities/ArticleFloor'
import ArticlePrice from '@Types/entities/ArticlePrice'
import ArticleFacility from '@Types/entities/ArticleFacility'
import Realtor from '@Types/entities/Realtor'
import ApiResponse from '@Types/inner/ApiResponse'

export type OwnerArticleState = ApiResponse<OwnerArticleResponse>
export const fetchOwnerArticle = createAsyncThunk('article/owner/fetchOwnerArticle', async (articleNo: string) => await (await landAxios.get(`/article/owner/${articleNo}`)).data)

export const fetchChangeIsAllowNotice = createAsyncThunk(
  'article/owner/fetchOwnerArticleChangeAlarm',
  async ({ encryptedArticleNo, isAllowNotice }: { encryptedArticleNo: string; isAllowNotice: boolean }) =>
    await (
      await landAxios.put(`/article/owner/notice/setting/${encryptedArticleNo}`, isAllowNotice.toString(), {
        headers: {
          'Content-Type': 'application/json',
        },
      })
    ).data,
)

export const fetchConfirmArticle = createAsyncThunk(
  'article/owner/fetchOwnerArticleConfirm',
  async (encryptedArticleNo: string) => await (await landAxios.put(`/article/owner/confirm/${encryptedArticleNo}`)).data,
)

const initialState: OwnerArticleState = {
  articleDetail: {} as ArticleDetail,
  articleFloor: {} as ArticleFloor,
  articlePrice: {} as ArticlePrice,
  articleFacility: {} as ArticleFacility,
  articleRealtor: {} as Realtor,
  articleName: '',
  isAllowNotice: true,
  isPending: false,
  isSuccess: false,
  isArticleConfirm: false,
} as OwnerArticleState

const ownerArticleSlice = createSlice({
  name: 'article/owner',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchOwnerArticle.fulfilled.type]: (state: OwnerArticleState, action: PayloadAction<OwnerArticleState>) => {
      state.isPending = true
      state.isSuccess = true
      Object.assign(state, action.payload)
    },
    [fetchOwnerArticle.rejected.type]: (state: OwnerArticleState, action: PayloadAction<OwnerArticleState>) => {
      state.isPending = true
      state.isSuccess = false
    },
    [fetchChangeIsAllowNotice.fulfilled.type]: (state: OwnerArticleState, action: PayloadAction<boolean>) => {
      state.isAllowNotice = action.payload
    },
    [fetchConfirmArticle.fulfilled.type]: (state: OwnerArticleState, action: PayloadAction<boolean>) => {
      state.isArticleConfirm = action.payload
    },
  },
})

export default ownerArticleSlice.reducer
